var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDados({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    transform: "translate(-5357 -2853)",
    fill: "#fff",
    stroke: "#707070",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    transform: "translate(45 1578)",
    fill: "#1d252c"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5357 2853)",
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(-5400 -4429)",
    clipPath: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20,12.375a8.25,8.25,0,1,1-9.625-8.126V6.875l3.437-3.437L10.375,0V2.86a9.62,9.62,0,1,0,11,9.515Z",
    transform: "translate(44.25 1578)",
    fill: "#1d252c"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDados);
export default __webpack_public_path__ + "static/media/dados.0ac5d64bc4c12566773eb73c8ba423d7.svg";
export { ForwardRef as ReactComponent };